import { createAction } from 'redux-actions';

export const GetListEventRequested = createAction('GET_LIST_EVENT_REQUESTED');
export const GetListEventReceived = createAction('GET_LIST_EVENT_RECEIVED');
export const GetListEventReceiveFailure = createAction('GET_LIST_EVENT_RECEIVE_FAILURE');
export const ClearListEvent = createAction('CLEAR_LIST_EVENT');

export const GetDetailEventRequestd = createAction('GET_DETAIL_EVENT_REQUESTED');
export const GetDetailEventReceived = createAction('GET_DETAIL_EVENT_RECEIVED');
export const GetDetailEventReceivedFailure = createAction('GET_DETAIL_EVENT_RECEIVED_FAILURE');
export const ClearGetDetailEvent = createAction('CLEAR_GET_DETAIL_EVENT');

export const CreateEventRequested = createAction('CREATE_EVENT_REQUESTED');
export const CreateEventReceived = createAction('CREATE_EVENT_RECEIVED');
export const CreateEventReceivedFailure = createAction('CREATE_EVENT_RECEIVED_FAILURE');
export const ClearCreateEvent = createAction('CLEAR_CREATE_EVENT');

export const EditEventRequested = createAction('EDIT_EVENT_REQUESTED');
export const EditEventReceived = createAction('EDIT_EVENT_RECEIVED');
export const EditEventReceivedFailure = createAction('EDIT_EVENT_RECEIVED_FAILURE');
export const ClearEditEvent = createAction('CLEAR_EDIT_EVENT');

export const GetListCompanyEventRequested = createAction('GET_LIST_COMPANY_EVENT_REQUESTED');
export const GetListCompanyEventReceived = createAction('GET_LIST_COMPANY_EVENT_RECEIVED');
export const GetListCompanyEventReceivedFailure = createAction('GET_LIST_COMPANY_EVENT_RECEIVED_FAILURE');
export const ClearGetListCompanyEvent = createAction('CLEAR_GET_LIST_COMPANY_EVENT');

export const DeleteEventRequested = createAction('DELETE_EVENT_REQUESTED');
export const DeleteEventReceived = createAction('DELETE_EVENT_RECEIVED');
export const DeletEventReceivedFailure = createAction('DELETE_EVENT_RECEIVED_FAILURE');
export const ClearDeleteEvent = createAction('CLEAR_DELETE_EVENT');

export const GetInfoEventRequested = createAction('GET_INFO_EVENT_REQUESTED');
export const GetInfoEventReceived = createAction('GET_INFO_EVENT_RECEIVED');
export const GetInfoEventReceivedFailure = createAction('GET_INFO_EVENT_RECEIVED_FAILURE');
export const ClearGetInfoEvent = createAction('CLEAR_GET_INFO_EVENT');

export const CreateRoleEventRequest = createAction('CREATE_ROLE_EVENT_REQUEST');
export const CreateRoleEventReceived = createAction('CREATE_ROLE_EVENT_RECEIVED');
export const CreateRoleEventFailure = createAction('CREATE_ROLE_EVENT_FAILURE');
export const ClearCreateRoleEvent = createAction('CLEAR_CREATE_ROLE_EVENT');
